import React, { useState, useEffect } from 'react'
import { useAuth } from '../../setup/AuthContext'
import { Navbar, Footer } from "../../components"
import { Profile, DashNavbar } from "../Dashboard"
import News from "../Publications/premiumNews/News"
import { db, auth } from '../../setup/Firebase'; // Import your Firebase instance
import { collection, doc, addDoc, getFirestore, onSnapshot } from "firebase/firestore";
// import { useAuthState } from 'react-firebase-hooks/auth'
export default function Dashboard() {

  return (
    <div className='emas__dashboard'>
      <Navbar />
      <DashNavbar />
      <News />
      <Footer />
    </div>
  )
}
